import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAowW6Pr2QZcGCRnpbQni4RFsDgEPRG7h8",
  authDomain: "plant-trees-again-all-green.firebaseapp.com",
  projectId: "plant-trees-again-all-green",
  storageBucket: "plant-trees-again-all-green.appspot.com",
  messagingSenderId: "188555144710",
  appId: "1:188555144710:web:d2b0ec657ef9ddb3e71d87"
};

initializeApp(firebaseConfig);

var Database = getDatabase();

export default Database;
